import { render, staticRenderFns } from "./videoCategory.vue?vue&type=template&id=ac5967ac&scoped=true"
import script from "./videoCategory.vue?vue&type=script&lang=js"
export * from "./videoCategory.vue?vue&type=script&lang=js"
import style0 from "./videoCategory.vue?vue&type=style&index=0&id=ac5967ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5967ac",
  null
  
)

export default component.exports